// eslint-disable-next-line css-modules/no-unused-class
import styles from './StatusBanner.module.css';
import classNames from 'classnames';

interface PendingBannerProps {
	children: React.ReactNode;
	status: 'approved' | 'pending';
}

export function StatusBanner({ children, status }: PendingBannerProps) {
	return (
		<div
			className={classNames(styles.StatusBanner, {
				[styles.approved]: status === 'approved',
				[styles.pending]: status === 'pending'
			})}
		>
			{children}
		</div>
	);
}
